import { Box, Link } from "@mui/material";
import { useTranslator } from "../i18n/translator";

export const Footer = () => {
  const translator = useTranslator();
  return (
    <Box
      component="footer"
      sx={{
        borderTop: "1px solid",
        borderColor: "divider",
        padding: 2,
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <Link href="/LICENSE.txt" target="_blank" rel="noopener">
        {translator("licenses")}
      </Link>
    </Box>
  );
};
